module.exports = __webpack_public_path__ + "img/89e6b30.png";